import { BLOG, BLUEPRINT, COMPANY, EXPERTISE, WORK } from 'Constants/Paths'

enum HeaderNavLinkId {
  Expertise = 'expertise',
  Work = 'work',
  Blueprint = 'blueprint',
  Company = 'company',
  Blog = 'blog',
}

export const HEADER_NAV_LINKS = [
  { id: HeaderNavLinkId.Expertise, label: 'Expertise', href: EXPERTISE },
  { id: HeaderNavLinkId.Work, label: 'Work', href: WORK },
  { id: HeaderNavLinkId.Blueprint, label: 'Blueprint', href: BLUEPRINT },
  { id: HeaderNavLinkId.Company, label: 'Company', href: COMPANY },
  { id: HeaderNavLinkId.Blog, label: 'Blog', href: BLOG },
]
